import { get, post } from '@/request/request';

export default {
  list(params) {
    return get('/admin/doc/contract/list', params);
  },
  info(params) {
    return get('/admin/doc/contract/info', params);
  },
  save(params) {
    return post('/admin/doc/contract/save', params);
  },
  delete(params) {
    return post('/admin/doc/contract/delete', params);
  }
};
